import { restApi } from '../../../services/Api'

const motoristaRepository = {
  motoristaKmm: cpf => {
    return restApi.get(`motoristaKmm/${cpf}`)
  }
}

export default motoristaRepository
